import { Skeleton } from '@/components/ui/skeleton.component';

export function SearchSkeletonRows({ rows }: { rows: number }) {
  return (
    <div className="space-y-10 ">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="flex flex-row items-start gap-3">
          <Skeleton className="w-12 h-12 min-w-12" />
          <div className="w-full space-y-2 flex items-center flex-col md:block">
            <Skeleton className="w-full h-3" />
            <Skeleton className="w-full h-[28px]" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SearchSkeletonLoading() {
  return (
    <div>
      <div className="flex space-x-3 mb-6 overflow-y-hidden mt-5">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="w-18 h-7" />
        ))}
      </div>
      <SearchSkeletonRows rows={10} />
    </div>
  );
}
